<script setup>
import ContactPanel from 'dashboard/routes/dashboard/conversation/ContactPanel.vue';

defineProps({
  currentChat: {
    required: true,
    type: Object,
  },
});

const emit = defineEmits(['toggleContactPanel']);


const toggleContactPanel = () => {
  emit('toggleContactPanel');
};

</script>

<template>
  <div
    class="h-full w-full flex flex-col bg-gradient-to-b from-white/80 to-slate-50/90 dark:from-slate-800/80 dark:to-slate-900/90 backdrop-blur-sm shadow-inner"
  >
    <!-- Mobile-only close button -->
    <div class="xl:hidden flex justify-end mt-5">
      <button
        class="inline-flex items-center text-sm font-medium text-slate-800 dark:text-slate-100 active:scale-[0.98] transition"
        @click="toggleContactPanel"
        aria-label="Close contact panel"
      >
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
          d="M9 5l7 7-7 7"
        />
      </svg> 
      </button>
    </div>
    <div class="flex flex-1 overflow-auto sidebar-scroll">
      <ContactPanel
        :conversation-id="currentChat.id"
        :inbox-id="currentChat.inbox_id"
        :on-toggle="toggleContactPanel"
        :show-contact-info="true"
      />
    </div>
  </div>
</template>
